var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lab-flask-experiment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.5,3.5v8L4.7,19.354A2,2,0,0,0,6.342,22.5H17.658A2,2,0,0,0,19.3,19.354L14.5,11.5v-8",
    id: "id_101",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.5,2.5a1,1,0,0,1-1,1h-7a1,1,0,0,1,0-2h7A1,1,0,0,1,16.5,2.5Z",
    id: "id_102",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.5,
    y1: 5.5,
    x2: 12.5,
    y2: 5.5,
    id: "id_103",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.5,
    y1: 9.5,
    x2: 12.5,
    y2: 9.5,
    id: "id_104",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.5,
    y1: 7.5,
    x2: 11.5,
    y2: 7.5,
    id: "id_105",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.057,
    y1: 15.5,
    x2: 16.943,
    y2: 15.5,
    id: "id_106",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.5,
    cy: 19,
    r: 1.5,
    id: "id_107",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,19.75a.75.75,0,1,0,.75.75.75.75,0,0,0-.75-.75Z",
    id: "id_108",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16.75a.75.75,0,1,0,.75.75.75.75,0,0,0-.75-.75Z",
    id: "id_109",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.371a42f903dc9831b23ec2878f31d5bc.svg";
export { ForwardRef as ReactComponent };